import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'GameLineSkeleton',
  values: {
    marketsCount: 3,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          height: '100%',
          padding: '0 8px',
        },
      },
    },
    selectionsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          justifyContent: 'flex-end',
        },
      },
    },
    selectionSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '60px',
          height: '45px',
          _desktop_width: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
